import React from 'react';

export default function CardDetailsSkeleton() {
  return (
    <div className="p-3 sm:p-4 md:p-6 text-white">
      <div className="flex flex-col lg:flex-row lg:gap-6 max-w-[1920px] mx-auto">
        {/* Text Content First */}
        <div className="flex-1 order-2 lg:order-none">
          {/* Title Section */}
          <div className="flex items-center gap-3 mb-6">
            <div className="h-8 bg-white/10 rounded w-48 animate-pulse" />
            <div className="h-8 bg-white/10 rounded-full w-8 animate-pulse" />
          </div>

          {/* Info Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3 sm:gap-4">
            <div className="space-y-2">
              {Array(4).fill(0).map((_, i) => (
                <div 
                  key={i} 
                  className="h-5 bg-white/10 rounded w-full animate-pulse"
                  style={{ animationDelay: `${i * 50}ms` }}
                />
              ))}
            </div>

            {/* Market Prices */}
            <div className="hidden sm:block bg-white/5 p-3 rounded-lg">
              <div className="h-5 bg-white/10 rounded w-1/3 mb-2 animate-pulse" />
              <div className="space-y-2">
                {Array(3).fill(0).map((_, i) => (
                  <div 
                    key={i} 
                    className="h-4 bg-white/10 rounded w-full animate-pulse"
                    style={{ animationDelay: `${i * 50}ms` }}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Attacks Section */}
          <div className="mt-6">
            <div className="h-6 bg-white/10 rounded w-32 mb-3 animate-pulse" />
            <div className="space-y-2">
              {Array(2).fill(0).map((_, i) => (
                <div 
                  key={i} 
                  className="bg-white/5 p-3 rounded-lg"
                  style={{ animationDelay: `${200 + i * 100}ms` }}
                >
                  <div className="flex justify-between items-center mb-2">
                    <div className="flex items-center gap-2">
                      <div className="h-5 bg-white/10 rounded-full w-5 animate-pulse" />
                      <div className="h-5 bg-white/10 rounded w-32 animate-pulse" />
                    </div>
                    <div className="h-5 bg-white/10 rounded w-16 animate-pulse" />
                  </div>
                  <div className="h-4 bg-white/10 rounded w-3/4 animate-pulse" />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Image Section Last */}
        <div className="w-full lg:w-80 xl:w-96 mb-6 lg:mb-0 order-1 lg:order-none">
          <div className="relative max-w-[288px] mx-auto lg:mx-0">
            <div className="aspect-[2.5/3.5] bg-white/10 rounded-lg animate-pulse delay-300" />
          </div>
          
          {/* Mobile Market Prices */}
          <div className="mt-4 bg-white/5 p-3 rounded-lg lg:hidden">
            <div className="h-5 bg-white/10 rounded w-1/3 mb-2 animate-pulse" />
            <div className="grid grid-cols-3 gap-2">
              {Array(3).fill(0).map((_, i) => (
                <div 
                  key={i} 
                  className="bg-white/5 p-2 rounded"
                  style={{ animationDelay: `${400 + i * 100}ms` }}
                >
                  <div className="h-3 bg-white/10 rounded w-2/3 mb-1 animate-pulse" />
                  <div className="h-4 bg-white/10 rounded w-full animate-pulse" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}